module.exports = "<span [ngClass]=\"setStatusStyle()\" >{{approvalStatus}}</span>\n"